<template>
  <svg width="24"
       height="100"
       viewBox="0 0 24 100"
       fill="none"
       xmlns="http://www.w3.org/2000/svg"
       class="timeline__decade__scale"
  >
    <rect v-for="lineNumber in linesCount"
          :key="lineNumber"
          :x="LINES_CONFIG.x[lineNumber - 1]"
          :y="LINES_CONFIG.y[lineNumber - 1]"
          :width="LINES_CONFIG.width[lineNumber - 1]"
          :height="LINES_CONFIG.height[lineNumber - 1]"
          :fill="LINES_CONFIG.fill[lineNumber - 1]"
          :opacity="lineNumber > disabledYearsCount ? '1' : '0.5'"
    />
  </svg>
</template>

<script>
const LINES_CONFIG = {
  x: [0, 14, 14, 14, 14, 10, 14, 14, 14, 14],
  y: [0, 10.9092, 21.8184, 32.7271, 43.6362, 54.5454, 65.4546, 76.3638, 87.2729, 98.1816],
  width: [24, 10, 10, 10, 10, 14, 10, 10, 10, 10],
  height: [2, 2, 2, 2, 2, 2, 2, 2, 2, 2],
  fill: ['#38383A', '#38383A', '#38383A', '#38383A', '#38383A', '#38383A', '#38383A', '#38383A', '#38383A', '#38383A']
}

export default {
  name: "TimelineDecadeScale",
  props: {
    disabledYearsCount: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      LINES_CONFIG,
      linesCount: 10
    }
  }
}
</script>